export default "__VITE_ASSET__SfT6hlQb__"